import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';

export type TakeOverExaminationParams = PatientCommandParams & {
	itemId: string,
};

export const TakeOverExamination = (
	params: TakeOverExaminationParams,
): Command => {
	return {
		operation: 'PrevezmiVymennyListok_v6',
		params,
	};
};
